import { render, staticRenderFns } from "./SampleCompareObject.vue?vue&type=template&id=7ed96c0e&scoped=true"
import script from "./SampleCompareObject.vue?vue&type=script&lang=js"
export * from "./SampleCompareObject.vue?vue&type=script&lang=js"
import style0 from "./SampleCompareObject.vue?vue&type=style&index=0&id=7ed96c0e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed96c0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ed96c0e')) {
      api.createRecord('7ed96c0e', component.options)
    } else {
      api.reload('7ed96c0e', component.options)
    }
    module.hot.accept("./SampleCompareObject.vue?vue&type=template&id=7ed96c0e&scoped=true", function () {
      api.rerender('7ed96c0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sample/SampleCompareObject.vue"
export default component.exports